"use strict";

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var common_1 = require("./common");

var webcrypto_driver_1 = require("./lib/crypto/webcrypto-driver");

common_1.default.init = function () {
  var apiConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  function getDefaultConfig() {
    var defaults = {
      host: "arweave.net",
      port: 443,
      protocol: "https"
    };

    if (!window || !window.location || !window.location.protocol || !window.location.hostname) {
      return defaults;
    } // window.location.protocol has a trailing colon (http:, https:, file: etc)


    var currentProtocol = window.location.protocol.replace(":", "");
    var currentHost = window.location.hostname;
    var currentPort = window.location.port ? parseInt(window.location.port) : currentProtocol == "https" ? 443 : 80;
    var isLocal = ["localhost", "127.0.0.1"].includes(currentHost) || currentProtocol == "file"; // If we're running in what looks like a local dev environment
    // then default to using arweave.net

    if (isLocal) {
      return defaults;
    }

    return {
      host: currentHost,
      port: currentPort,
      protocol: currentProtocol
    };
  }

  var defaultConfig = getDefaultConfig();
  var protocol = apiConfig.protocol || defaultConfig.protocol;
  var host = apiConfig.host || defaultConfig.host;
  var port = apiConfig.port || defaultConfig.port;
  return new common_1.default({
    api: Object.assign({}, apiConfig, {
      host: host,
      protocol: protocol,
      port: port
    }),
    crypto: new webcrypto_driver_1.default()
  });
};

window.Arweave = common_1.default;

__export(require("./common"));

exports.default = common_1.default;